module.exports = __webpack_public_path__ + "img/middle-discharging-start.d5cc95d6.png";